import Vue from 'vue'
import VueRouter from 'vue-router'
import proxyRouters from './proxy'
import userRouters from './user'
import publicRouters from './public'
import i18n from '@/utils/i18n'

Vue.use(VueRouter)

const routes = [
  { path: '/trade-ledger', name: 'tradeLedger', component: () => import('../views/tradeLedger.vue') },
  {
    path: '/',
    // redirect: '/proxy'
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/page')
  },
  publicRouters,
  proxyRouters,
  userRouters,
  {
    path: '/sign', // 登录入口
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/signEntry'),
    children: [
      {
        path: 'sign-in', // 登录
        name: 'signIn',
        meta: {
          title: i18n.t('public73') // '登录'
        },
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/sign/signIn.vue')
      },
      {
        path: 'sign-up', // 注册
        name: 'signUp',
        meta: {
          title: i18n.t('public77') // '注册'
        },
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/sign/signUp/index.vue')
      },
      {
        path: 'find-pass', // 注册
        name: 'findPass',
        meta: {
          title: i18n.t('public39') // '找回密码'
        },
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/sign/findPass.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
